import { DateTime } from 'luxon';
import { useIntl } from 'react-intl';

import { ContentWrapper } from '@/components/dtcPartnerships/shared/styles';
import { useAnalytics } from '@/hooks/analytics';
import { useDeviceState, useUserState } from '@/hooks/store';
import { useComponentDidMount } from '@/hooks/utils/useComponentDidMount';
import genericMessages from '@/messages/messages';
import { CALM_ONE_LINKS } from '@/utils/deeplinks/deeplinks';

import messages from './messages';
import { Grid, SorryButton, SorryText, UnderlinedLink } from './styles';

const Sorry = () => {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();
	const device = useDeviceState();
	const user = useUserState();

	useComponentDidMount(() => {
		logEvent({ eventName: 'Sorry : Landed' });
	});

	function onCtaClick(): void {
		let url = CALM_ONE_LINKS.login;
		if (device.isMobile) {
			if (process.env.NEXT_PUBLIC_CALM_ENV === 'production') {
				url = 'calm://upsell';
			}
			url = 'calm-dev://upsell';
		}

		logEvent({
			eventName: 'Sorry : CTA : Clicked',
			eventProps: {
				url,
			},
		});
		window.location.assign(url);
	}

	const expires = user?.subscription?.expires
		? DateTime.fromISO(user.subscription.expires).toLocaleString(DateTime.DATE_SHORT)
		: 'n/a';

	return (
		<Grid allowOverflow>
			<ContentWrapper>
				<SorryText>
					{formatMessage(messages.cancelToRedeemDTC, {
						breakingLine: <p />,
						subscriptionEndDate: expires,
						cancelationinstructions: (...chunks) => (
							<UnderlinedLink href="https://support.calm.com/hc/en-us/articles/115002473607">
								{chunks}
							</UnderlinedLink>
						),
						p: (...chunks) => <p>{chunks}</p>,
						bold: (...chunks) => <b>{chunks}</b>,
						ul: (...chunks) => <ul>{chunks}</ul>,
						ol: (...chunks) => <ol>{chunks}</ol>,
						li: (...chunks) => <li>{chunks}</li>,
					})}
				</SorryText>
				<SorryButton onPress={onCtaClick}>{formatMessage(genericMessages.openCalmApp)}</SorryButton>
			</ContentWrapper>
		</Grid>
	);
};

export default Sorry;
